<template>
  <div class="blog-header">
    <container>
      <div class="blog-header__wrp">          
        <div class="blog-header__left">
          <div slot="bread">
<li class="mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a href="/" class="" itemtype="https://schema.org/Thing" itemprop="item">
<span itemprop="name">holywoodskyline.com</span><span>&nbsp;/&nbsp;</span>
</a>
<meta itemprop="position" content="1" />
</li>
<li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a href="/blog" class="" itemtype="https://schema.org/Thing" itemprop="item">
<span itemprop="name"> Blog </span>
</a>
<meta itemprop="position" content="2" />
</li>
<li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a v-if="blogCategory !=''" :href="blogSlug" class="" itemtype="https://schema.org/Thing" itemprop="item">
&nbsp;/&nbsp;<span itemprop="name">{{ blogCategory }} </span>
</a>
<meta itemprop="position" content="3" />
</li>
          </div> 
          <h1 class="blog-header__title color-white">
            <!-- <span class="color-light-green">holywoodskyline.com</span> -->
            <span class="color-purple" v-if="!blogTitle"> {{ blogCategory }}</span>
            <span class="color-purple" v-if="blogTitle"> Blog </span>
          </h1>
          <p class="blog-header__txt">
            Discover articles, news and galleries tailored for you about the movie, TV series and the celebrity you are curious about! Get information about entertainment venues for movies enthusiasts, movies to watch, best shows, television shows, the program and the best events, and the life of hollywood and celebrities!
          </p>
          <div class="blog-header-social">
            <div class="blog-header-social__title">
              Follow Us On Our Social Network !
            </div>
            <SocialGroup />
          </div>
        </div>
        <div class="blog-header__right">
          <img src="@/assets/img/shapes/shape-14.svg" alt="hollywood movies" class="shape-11">
          <img src="@/assets/img/shapes/shape-12.svg" alt="hollywood movies" class="shape-12">
          <img src="@/assets/img/blog-shape.svg" alt="holywoodskyline blog" class="blog-header__shape">
          <svg class="shape-13" version="1.1" x="0px" y="0px" viewBox="0 0 838.1 166.8">
            <path class="st0" d="M3.2,166.8L88.6,39.6C105.2,14.9,133,0,162.8,0h353.6c23.6,0,46.2,9.4,62.8,26.2l45.8,46h28.2  c17.4,0,34.1,7,46.4,19.3l16.9,17h47.2c9.9,0,19.3,3.9,26.3,10.9l47.2,47.4H3.2z"/>
          </svg>
        </div>
      </div>
    </container>
  </div>
</template>

<script>
import SocialGroup from '@/components/SocialGroup'
import { mapGetters } from 'vuex'
import { SET_BLOG_CATEGORY_TITLE, SET_BLOG_CATEGORY_SLUG } from '@/store/mutations.type'
export default {
  name: 'BlogHeader',
  components: {
    SocialGroup
  },
  data () {
  return {
        blogTitle: false
  }
  },
  computed: {
    ...mapGetters(['blogCategory', 'blogSlug']),
  },
              created () {
                              if(this.$route.fullPath ==='/blog') {
                this.blogTitle = true
                      this.$store.commit(SET_BLOG_CATEGORY_TITLE, '' )
              } else {
                this.blogTitle = false
              }
              } 
}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/components/blog-header";
</style>
